import styled from "../../../config/emotion";
import ewaBackground from "../../../assets/img/ewa_background.png";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-image: url(${ewaBackground});
  background-repeat: no-repeat;
  background-position: right top;
  background-color: #f1f1f1;
`;

export const PageNotFoundElement = styled.img`
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media only screen and (max-width: 768px) {
    width: 200px;
  }
`;
